import { render } from "./FooterDigdaya.vue?vue&type=template&id=39c24e3b"
import script from "./FooterDigdaya.vue?vue&type=script&lang=js"
export * from "./FooterDigdaya.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__